import graphqlRequest from '../assessmentRequest';

const GET_BLUEPRINTS = `query generateManifest($assignmentType: String!, $schoolId: String!, $districtId: String!) {
    generateManifest(assignmentType: $assignmentType, schoolId: $schoolId , districtId: $districtId) {
        activities {
            activityType
            sequence
            locale
        }
    }
}`;

export async function fetchManifest({
  assignmentType,
  schoolId,
  districtId,
}: {
  assignmentType: string;
  schoolId: string;
  districtId: string;
}) {
  return await graphqlRequest(GET_BLUEPRINTS, {
    assignmentType,
    schoolId,
    districtId,
  });
}
